import type { ParentProps } from 'solid-js'
import Root from './root'

function Container(props: ParentProps) {
	return <>{props.children}</>
}

const routes = [
	{
		path: '/updates',
		component: Container,
		children: [
			{
				path: '/',
				component: Root,
			},
		],
	},
]

export default routes
